import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeartbeat } from '~/api/application';
import { Illustration, Text, Title } from '~/components';

import { centerContainerStyle, coffeeStyle, contentWrapperStyle, textWrapperStyle } from './MaintenanceScreen.css';

export const MaintenanceScreen = () => {
  useHeartbeat();

  const { t } = useTranslation(['common']);

  const [coffee] = useState(() => (Math.random() > 0.5 ? ('Coffee1' as const) : ('Coffee2' as const)));

  return (
    <div className={centerContainerStyle}>
      <div className={contentWrapperStyle}>
        <Illustration className={coffeeStyle} name={coffee} strokeWidth={2} />

        <div className={textWrapperStyle}>
          <Title as="h2">{t('common:maintenance.title')}</Title>
          <Text>{t('common:maintenance.description')}</Text>
        </div>
      </div>
    </div>
  );
};
